/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { showSnackbar, hideSnackbar } from "../../actions";

const CommonAlert = ({
  showSnackbar,
  hideSnackbar,
  common: { isSnackbarOpen, snackbarType, snackbarMsg },
}) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    hideSnackbar();
  };

  return (
    <div>
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </div>
  );
};

CommonAlert.propTypes = {
  showSnackbar: PropTypes.func.isRequired,
  hideSnackbar: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  common: state.commonState,
});

export default connect(mapStateToProps, {
  showSnackbar,
  hideSnackbar,
})(CommonAlert);
